/*
 * Copyright 2018-2022 CommScope, Inc., All rights reserved.
 *
 * This program is confidential and proprietary to CommScope, Inc. (CommScope), and
 * may not be copied, reproduced, modified, disclosed to others, published or used, in
 * whole or in part, without the express prior written permission of CommScope.
 */

// import { ErrorModal } from 'app/components/modals';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';

import { createShowPanelSelector } from 'app/redux/app';
import { vertSSIDFilterSelector } from 'app/redux/filters';
import {
  hierarchyNodeSelected,
  hierarchySelector,
  rootNodeSelector,
  selectedPathSelector
} from 'app/redux/hierarchy';
import {
  reportError,
  fetchClientReport,
  setClientReportGenerated,
  downloadErrorSelector,
  generateInProgressSelector,
  clientReportFetchStateSelector,
  clientReportGeneratedSelector
} from 'app/redux/reports';
// import { closeModal, openModal } from 'app/redux/ui';
import { isSpecificNodeType } from 'app/components/layout/components/sidebar/utils';
import GenerateConsolidatedClientReport from './generate-consolidated-client-report';

// const reportErrorModalKey = 'report-download-error';

class ClientReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clientReport: false
    };
  }

  // Generator Report button will be enabled when the path is changed at any hierarchy level.

  componentDidUpdate = prevProps => {
    const { selectedPath, setClientReportGenerated } = this.props;
    const { selectedPath: prevPath } = prevProps;
    const nodeChanged = isSpecificNodeType(selectedPath, 'zonename') && !isEqual(prevPath.id, selectedPath.id);

    if (nodeChanged) {
      this.setState({ clientReport: false }, () => {
        setClientReportGenerated();
      });
    }
  };

  // closeErrorModal = () => {
  //   const { closeModal, reportError } = this.props;
  //   closeModal(reportErrorModalKey);
  //   reportError({});
  // };

  // getReportError = () => {
  //   const {
  //     downloadError: { type, error }
  //   } = this.props;
  //   if (isEqual(type, 'client-report')) {
  //     if (isEqual(get(error, 'message'), 'No data')) {
  //       return 'No Device Data Available!';
  //     }
  //     return 'Failed to generate device report!';
  //   }
  //   return 'No Device Data Available!';
  // };

  toggleGenerateReport = report => () =>
    this.setState(prevState => ({ [report]: !prevState[report] }));

  render = () => {
    const {
      // downloadError,
      fetchClientReport,
      showGenerateClientReport,
      isClientReportGenerated,
      setClientReportGenerated
    } = this.props;
    const { clientReport } = this.state;

    // const hasReportError = !isEmpty(downloadError);

    return (
      <Fragment>
        {showGenerateClientReport && (
          <GenerateConsolidatedClientReport
            {...this.props}
            handleGenerateReport={fetchClientReport}
            showGenerate={clientReport}
            toggleGenerate={this.toggleGenerateReport('clientReport')}
            updateTableReportStatus={setClientReportGenerated}
            isClientReportGenerated={isClientReportGenerated}
          />
        )}
        {/* {hasReportError && (
          <ErrorModal
            closeModal={this.closeErrorModal}
            message={this.getReportError()}
          />
        )} */}
      </Fragment>
    );
  };
}

ClientReports.propTypes = {
  setClientReportGenerated: PropTypes.func.isRequired,
  // closeModal: PropTypes.func.isRequired,
  // openModal: PropTypes.func.isRequired,
  reportError: PropTypes.func.isRequired,
  hierarchyNodeSelected: PropTypes.func,
  fetchClientReport: PropTypes.func.isRequired,
  downloadError: PropTypes.object,
  hierarchy: PropTypes.object,
  selectedPath: PropTypes.object,
  vertSSIDFilter: PropTypes.object.isRequired,
  rootNode: PropTypes.object,
  clientReportFetchState: PropTypes.object,
  showGenerateClientReport: PropTypes.bool,
  isClientReportGenerated: PropTypes.bool
};

const mapStateToProps = createSelector(
  createShowPanelSelector('ReportsGenerateClientReport'),
  downloadErrorSelector,
  generateInProgressSelector,
  hierarchySelector,
  selectedPathSelector,
  vertSSIDFilterSelector,
  clientReportFetchStateSelector,
  rootNodeSelector,
  clientReportGeneratedSelector,
  (
    showGenerateClientReport,
    downloadError,
    generateInProgress,
    hierarchy,
    selectedPath,
    vertSSIDFilter,
    clientReportFetchState,
    rootNode,
    isClientReportGenerated
  ) => ({
    showGenerateClientReport,
    downloadError,
    generateInProgress,
    hierarchy,
    selectedPath,
    vertSSIDFilter,
    clientReportFetchState,
    rootNode,
    isClientReportGenerated
  })
);

const mapDispatchToProps = {
  // closeModal,
  // openModal,
  reportError,
  hierarchyNodeSelected,
  fetchClientReport,
  setClientReportGenerated
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientReports);
